import React from 'react';

import NextImageV2 from '../../../../ui/components/NextImageV2';
import { oms_url } from '../../../config/AppConfig';
import { FooterContentEntity } from '../../domain/entities/FooterContentEntity';
import styles from '../styles/Footer.module.scss';

import FooterDownloadAppCmp from './FooterDownloadAppCmp';
import FooterDownloadQrCmp from './FooterDownloadQrCmp';
import FooterSocialMediaCmp from './FooterSocialMediaCmp';

interface FooterBrandSectionCmpProps {
  footer_data?: FooterContentEntity;
  isDesktop: boolean;
  query_params: string;
}

function FooterBrandSectionCmp({
  footer_data,
  isDesktop,
  query_params,
}: Readonly<FooterBrandSectionCmpProps>): React.ReactElement {
  return (
    <div className={styles['footer-brand-section']}>
      <a href={oms_url + query_params}>
        {footer_data ? (
          <NextImageV2
            src={footer_data.logo.path}
            width={152.5}
            height={25}
            quality={75}
            alt="Porter Logo"
          />
        ) : (
          <div />
        )}
      </a>
      <div className={styles['download-app-mobile-container']}>
        <FooterDownloadAppCmp
          styles={styles}
          isDesktop={isDesktop}
          footer_data={footer_data}
        />
      </div>
      <div className={styles['dotted-divider']} />
      <div className={styles['footer-tertiary']}>
        <FooterSocialMediaCmp
          socialMediaLinks={footer_data?.social_links.social_media_links}
        />
        <FooterDownloadQrCmp footer_data={footer_data} isDesktop={isDesktop} />
      </div>
    </div>
  );
}

export default FooterBrandSectionCmp;
